var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagCn = function SvgFlagCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flag_cn_svg__a",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#flag_cn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E31D1C",
    d: "M0 0h16v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECA00",
    d: "M3.556 4.878 1.61 6.403l.743-2.307-1.298-1.2 1.757-.065.744-1.857.744 1.857h1.755L4.76 4.096l.59 2.307zM7.508 3.086l-.817.493.187-.962-.68-.72.92-.04.39-.898.39.899h.92l-.68.759.205.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECA00",
    d: "m8.508 5.086-.817.493.187-.962-.68-.72.92-.04.39-.898.39.899h.92l-.68.759.205.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECA00",
    d: "m7.508 7.086-.817.493.187-.962-.68-.72.92-.04.39-.898.39.899h.92l-.68.759.205.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECA00",
    d: "m5.508 8.086-.817.493.187-.962-.68-.72.92-.04.39-.898.39.899h.92l-.68.759.205.962z"
  }))));
};
export default SvgFlagCn;